export const state = () => ({
  answerBody: null,
});

export const mutations = {
  setAnswerBody(state, answerBody) {
    state.answerBody = answerBody;
  },
};
